

import { VisibilityOff, Visibility } from "@mui/icons-material";
import { FormControl, InputLabel, OutlinedInput, InputAdornment, IconButton, Button, Link, Alert, Collapse } from "@mui/material";
import React, { useEffect, useState } from "react";
import { apiUrl } from "../../environment";
import { coreService } from "../../services/core.service";
import axios from "axios";
import PopupMessageComponent from "../popup-message/popup-message";

const initialFormValues = {
    token: "",
    password: "",
    confirmPassword: "",
};

const ResetPasswordForm = (props: {setSuccessOpen: Function, setForgotPassword: Function}) => {
    const [formValues, setFormValues] = useState(initialFormValues);
    const [formSubmit, setFormSubmit] = useState(false);
    const [passwordSet, setPasswordSet] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogMessage, setDialogMessage] = useState({
        title: "",
        content: "",
    });

    const emptyForm = !formValues.token || !formValues.password || formValues.password != formValues.confirmPassword;

    const handleInputChange = (e: any) => {
        const { name, value } = e.target;
        setFormValues({
            ...formValues,
            [name]: value,
        });
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
        setFormSubmit(true);
        var params = new URLSearchParams({ token: formValues.token, password: formValues.password, })
        axios({
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            url: `${apiUrl}/ResetPassword`,
            data: params.toString(),
        })
        .then((res) => {
            setFormSubmit(false);
            setPasswordSet(true)
            setFormValues(initialFormValues);
        })
        .catch((error) => {
            setFormSubmit(false);
            setDialogMessage({
                title: "Error",
                content: "An error has occurred. Please try again.",
            });
            setDialogOpen(true);
        });
    };

    return (
        <div>
            <div className="mb-4">Using the details in the email, provide your token and new password to proceed.</div>
            <form onKeyUp={(e) => {e.key == 'Enter' && handleSubmit(e)}}>
                <FormControl fullWidth variant="outlined" className="mb-4">
                    <InputLabel htmlFor="outlined-adornment-password">Token</InputLabel>
                    <OutlinedInput name="token" type="text" autoComplete="one-time-code" value={formValues.token} onChange={handleInputChange} label="Token" />
                </FormControl>
                <FormControl fullWidth variant="outlined" className="mb-4">
                    <InputLabel htmlFor="outlined-adornment-password">New Password</InputLabel>
                    <OutlinedInput name="password" type="password" autoComplete="new-password" value={formValues.password} onChange={handleInputChange} label="Password" />
                </FormControl>
                <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-password">Confirm Password</InputLabel>
                    <OutlinedInput  name="confirmPassword" type="password" autoComplete="new-password" value={formValues.confirmPassword} onChange={handleInputChange} label="Confirm Password" />
                </FormControl>
                <Button className="w-100 mt-4" variant="contained" size="large" onClick={handleSubmit} disabled={emptyForm || formSubmit}>
                    Reset Password
                </Button>
            </form>
            <div className="d-flex justify-content-between mt-4">
                <Link className="cursor-pointer" color={'primary'} onClick={() => props.setSuccessOpen(false)}><small>Back</small></Link>
            </div>
            <Collapse in={passwordSet}>
                <Alert color="success">
                    Password reset successfully. <Link href="/" className="cursor-pointer" color={'primary'}>Proceed to Login</Link>.
                </Alert>
            </Collapse>
            <PopupMessageComponent message={dialogMessage} open={dialogOpen} setOpen={setDialogOpen} />
        </div>
    )
}

export default ResetPasswordForm;